import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { loadSearch, SearchResponse } from './requests';

export const useSearch = (
  searchString: string,
  options: { onSuccess?: (data: SearchResponse) => void; enabled?: boolean } = {},
) => {
  return useQuery<SearchResponse, AxiosError>({
    queryKey: ['search', searchString],
    queryFn: () => loadSearch(searchString),
    keepPreviousData: true,
    ...options,
  });
};
